class ContactFormContainer extends HTMLElement {
  constructor() {
    super()

    this.querySelector('button[type="submit"]')?.addEventListener(
      'click',
      this.onSubmitHandler.bind(this)
    )

    const inputs = this.querySelectorAll('form input')
    inputs.forEach((el) => {
      el.addEventListener('keypress', (e) => {
        if (e.keyCode == 13) {
          this.onSubmitHandler(e)
        }
      })
    })

    const selects = this.querySelectorAll('form select')
    selects.forEach((el) => {
      el.addEventListener('change', (e) => {
        if (el.value) {
          el.classList.add('filled')
        } else {
          el.classList.remove('filled')
        }
      })
    })
  }

  onSubmitHandler(e) {
    e.preventDefault()
    e.stopPropagation()

    this.formValidation()
  }

  formValidation () {
    const form = this.querySelector('form')

    if (form) {
      const inputs = this.querySelectorAll('input.required:not([type="hidden"]), select.required, textarea.required')
      var allValidated = true;

      inputs.forEach((el) => {
        if (el.value) {
          el.closest('.field').classList.remove('error')
        } else {
          allValidated = false
          el.closest('.field').classList.add('error')
        }
      })

      if (allValidated) {
        form.submit()
      }
    }
  }
}

customElements.define('contact-form-container', ContactFormContainer)
